import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const ContactPage = () => {
  const contactInfo = [
    {
      icon: "📍",
      title: "Location",
      content: "Mruma street, nearby Msigani Luxury\nMSIGANI ward, Ubungo District\nDar es Salaam, Tanzania"
    },
    {
      icon: "📮",
      title: "Postal Address",
      content: "P.O. Box 78223\nDar es Salaam, Tanzania"
    },
    {
      icon: "🌍",
      title: "Area of Operation",
      content: "National Coverage\nTanzania"
    }
    // ,
    // {
    //   icon: "📧",
    //   title: "Email",
    //   content: "info@caei.or.tz\nsupport@caei.or.tz"
    // }
    ,
    {
      icon: "📞",
      title: "Phone",
      content: "+255 760 300 246\n+255 663 583 019"
    }
  ];

  return (
    <div className="contact-page">
      <div className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <div className="page-badge">Get In Touch</div>
            <h1 className="page-title-animated">Contact Us</h1>
            <p className="page-subtitle">
              We're here to help and support you. Reach out to us anytime.
            </p>
          </div>
        </div>
      </div>

      <div className="container page-content">
        <section className="contact-intro">
          <div className="overview-content">
            <h2 className="overview-title">Connect With Us</h2>
            <div className="overview-text">
              <p>
                Whether you need support, want to learn more about our programs, or are interested in partnering with us, we welcome your inquiries. Our team is committed to responding promptly and providing the assistance you need.
              </p>
              <p className="highlight-text">
                All communications are treated with confidentiality and respect. We are here to listen and support you.
              </p>
            </div>
          </div>
        </section>

        <section className="contact-details-section">
          <div className="contact-grid-with-bg">
            {contactInfo.map((info, index) => (
              <div className="contact-card" key={index}>
                <div className="contact-icon-large">{info.icon}</div>
                <h3>{info.title}</h3>
                <p className="contact-text">
                  {info.content.split('\n').map((line, i) => (
                    <React.Fragment key={i}>
                      {line}
                      {i < info.content.split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="contact-map-section">
          <div className="map-container">
            <h3>Visit Our Office</h3>
            <p>Mruma street, nearby Msigani Luxury, MSIGANI ward, Ubungo District, Dar es Salaam</p>
            <div className="map-embed">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d498.67378284126795!2d39.11577298356177!3d-6.789571404787152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x185c45b5bbc3c293%3A0x620bfedb83742b08!2sMsigani%20Luxury%20Night%20Club!5e0!3m2!1sen!2stz!4v1773076914334!5m2!1sen!2stz" 
                width="100%" 
                height="450" 
                style={{border: 0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="CAEI Office Location"
              ></iframe>
            </div>
          </div>
        </section>

        <div className="page-nav-footer">
          <Link to="/" className="btn btn-primary">← Back to Home</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
